// @flow
import React, {type Node} from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

import './scrollBar.scss';

type PropsType = {
    className: string,
    onScrollY: () => HTMLDivElement,
};

/**
 * Wrapper on perfect scroll bar
 * @param {PropsType} props - props
 * @returns {Node} Rendered react component
 */
// $FlowFixMe
export const ScrollBar = React.forwardRef(
    // $FlowFixMe
    (props: PropsType, ref: {current: HTMLDivElement | null}): Node => {
        return <PerfectScrollbar {...props} ref={ref} />;
    },
);
